import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import TabletContext from 'contexts/TabletContext';

export interface WithTabletProps {
    isTablet: boolean;
}

export default function withTablet<T extends WithTabletProps>(
    WrappedComponent: React.ComponentType<T>,
) {
    class WithTablet extends React.Component<Omit<T, keyof WithTabletProps>> {
        static displayName = `withTablet(${
            WrappedComponent.displayName || WrappedComponent.name || 'Component'
        })`;
        static contextType = TabletContext;

        render() {
            return <WrappedComponent {...(this.props as T)} isTablet={this.context} />;
        }
    }

    // Copies non-react specific statics from a child component to a parent component
    hoistNonReactStatics(WithTablet, WrappedComponent);
    return WithTablet;
}
